import { getDayLabelNumber } from "./wordForm";

export function getQueryParams(query) {
  if (!query || !Object.keys(query).length) {
    return {};
  }

  query.page = query.page ? query.page : 0;

  if (query.number && parseInt(query.number, 10) <= 0) {
    delete query.number;
  } else {
    query.number = parseInt(query.number, 10);
  }

  if (query.view && query.view !== "all") {
    delete query.view;
  }

  return query;
}

export function getStatusString(status, toLowerCase = false, isBilet = false) {
  // run, continue, repayment, close, on_sale, return, delete
  let returnString = "";

  switch (status) {
    case "create":
      returnString = "Создание";
      break;
    case "run":
      returnString = isBilet ? "Создание" : "В действии";
      break;
    case "continue":
      returnString = "Пролонгация";
      break;
    case "repayment":
      returnString = "Выкуп";
      break;
    case "close":
      returnString = "Списание";
      break;
    case "on_sale":
      returnString = "Списание";
      break;
    case "return":
      returnString = "Выкуп";
      break;
    case "delete":
      returnString = "Удаленён";
      break;
    case "login":
      returnString = "Вход";
      break;
    case "register":
      returnString = "Регистрация";
      break;
    default:
      returnString = status;
      break;
  }

  if (toLowerCase) {
    returnString = returnString.toLowerCase();
  }

  return returnString;
}

/**
 * Получить стиль для статуса билета
 * @param {String} status Статус билета
 * @param {String} isReturnOnlyColor Вернуть только цвет, без префикса
 * @returns {String}
 */
export function getStatusClassString(status, isReturnOnlyColor) {
  // run, continue, repayment, close, on_sale, return, delete
  let returnString = "";

  switch (status) {
    case "create":
      returnString = "dark";
      break;
    case "run":
      returnString = "dark";
      break;
    case "continue":
      returnString = "warning";
      break;
    case "repayment":
      returnString = "error";
      break;
    case "close":
      returnString = "success";
      break;
    case "on_sale":
      returnString = "success";
      break;
    case "return":
      returnString = "error";
      break;
    case "delete":
      returnString = "error";
      break;
    default:
      returnString = status;
      break;
  }

  if (returnString.length) {
    returnString = (isReturnOnlyColor ? "" : "color-") + returnString;
  }

  return returnString;
}

/**
 * Получить статус штрафа
 * @param {Object} fine Штраф
 * @param {boolean} toLowerCase Маленькими буквами?
 * @returns {String}
 */
export function getStatusFineString(fine, toLowerCase = false) {
  // run, continue, repayment, close, on_sale, return, delete
  let returnString = "";

  switch (fine._type) {
    case "delay":
      returnString = `Задержка билета на ${getDayLabelNumber(fine.days_fine)}`;
      break;
    case "lost":
      returnString = "Потеря билета";
      break;
    default:
      returnString = fine._type;
      break;
  }

  if (toLowerCase) {
    returnString = returnString.toLowerCase();
  }

  return returnString;
}

/**
 * Получить процент штрафа
 * @param {Object} fine Штраф
 * @returns {String|Number} '- || Цифра'
 */
export function getFinePercentBilet(fine) {
  if (fine._type === "delay") {
    return fine.percent_fine;
  } else {
    return "-";
  }
}

/**
 * Получить дни штрафа
 * @param {Object} fine Штраф
 * @returns {String}
 */
export function getFineDaysBilet(fine) {
  if (fine._type === "delay") {
    return getDayLabelNumber(fine.days_fine);
  } else {
    return "-";
  }
}
